













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IColumnDef } from '../../interfaces/ag-grid'
import { Playlist, PLAYLIST_TYPES } from '../../classes/playlist'
const AgGridVue = () => import(`@/modules/ag-grid`)

interface IAgTrackNode {
  data: Playlist | string
  selected: boolean
  setSelected: Function
  setExpanded: Function
  parent: any
}

function moveInArray(arr: any[], fromIndex: number, toIndex: number) { // TODO: replace with lodash?
  const element = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, element)
}

@Component({
  components: {
    AgGridVue
  }
})
export default class PlaylistSelector extends Vue {
  @Prop()
  nextFunction: Function

  @Prop()
  prevFunction: Function

  @Prop({
    default: 'Next'
  })
  nextLabel: string

  @Prop({
    default: 'Back'
  })
  prevLabel: string

  @Prop()
  nextDisabled: boolean

  @Prop()
  allowMultiple: boolean

  @Prop({
    default: true
  })
  allowNextForDemo: boolean

  @Prop()
  loading: boolean

  @Prop()
  value: Playlist[]

  @Prop()
  customPlaylists: Playlist[]

  @Prop({
    default: false
  })
  allowFolderSelection: boolean

  @Prop({
    default: false
  })
  showTrackCount: boolean

  @Prop({
    default: false
  })
  allowDrag: boolean

  selectedPlaylists: Playlist[] = this.value
  playlistsModel: Playlist[] = []

  quickFilterModel: string | null = null
  gridApi: any
  columnApi: any
  sortActive: boolean = false

  columnDefs: IColumnDef[] = [
    {
      headerName: 'Playlist',
      field: 'name',
      cellRenderer: 'agGroupCellRenderer',
      checkboxSelection: true,
      resizable: true,
      rowDrag: this.allowDrag, // TODO: reactive
      width: 300,
      valueGetter: (rowItem: { data: Playlist }) => {
        let name: string = rowItem.data.name

        if (this.showTrackCount && rowItem.data.type === PLAYLIST_TYPES.Playlist) {
          const trackCount: number = rowItem.data.tracks ? rowItem.data.tracks.length : 0

          name = `${name} (${trackCount})`
        }

        return name
      },
      cellRendererParams: {
        suppressCount: true
      }
    }
  ]

  get playlists(): Playlist[] {
    if (this.customPlaylists) {
      return this.customPlaylists
    } else {
      return this.$store.getters['library/playlists']
    }
  }

  clearFilters() {
    this.quickFilterModel = null
    this.gridApi.setFilterModel(null)
  }

  onGridReady(params: any) {
    this.gridApi = params.api
    this.columnApi = params.columnApi

    this.playlistsModel = this.playlists

    params.api.setRowData(this.playlistsModel)

    this.gridApi.cacheQuickFilter = true

    this.gridApi.sizeColumnsToFit()

    const playlistIdObj: {
      [key: string]: boolean
    } = {}

    for (const playlist of this.selectedPlaylists) {
      playlistIdObj[playlist._id] = true
    }

    this.gridApi.forEachNode((node: IAgTrackNode) => {
      if (playlistIdObj[(node.data as Playlist)._id]) {
        node.setSelected(true, false, true) // Note: this disables re-rerender
      }
    })

    let hasRerendered = false
    this.gridApi.forEachNode((node: IAgTrackNode) => {
      if (!hasRerendered) {
        if (playlistIdObj[(node.data as Playlist)._id]) {
          node.setSelected(false)
          node.setSelected(true)
          hasRerendered = true
        }
      }
    })
  }

  onRowSelected(rowItem: any) {
    const playlist: Playlist = rowItem.node.data as Playlist

    const isPlaylistSelected: boolean = this.selectedPlaylists.some(x => x._id === playlist._id)

    if (rowItem.node.selected && !isPlaylistSelected) {
      this.selectedPlaylists.push(playlist)
    } else if (!rowItem.node.selected && isPlaylistSelected) {
      const index: number = this.selectedPlaylists.findIndex(x => x._id === playlist._id)

      this.selectedPlaylists.splice(index, 1)
    }

    this.$emit('input', this.selectedPlaylists)
  }

  onRowDragEnd() {
    this.emitTracks()
  }

  onSortChanged() {
    const sortModel = this.gridApi.getSortModel()
    this.sortActive = sortModel && sortModel.length > 0
    const suppressRowDrag = this.sortActive

    this.gridApi.setSuppressRowDrag(suppressRowDrag)

    this.emitTracks()
  }

  emitTracks() {
    console.log('emit') // TODO:
    // let tracksOrdered: Track[] = []

    // if (this.gridApi) {
    //   const nodesOrdered: any[] = []

    //   this.gridApi.forEachNode((x: any) => nodesOrdered.push((x)))

    //   nodesOrdered.sort((a, b) => a.childIndex - b.childIndex)

    //   tracksOrdered = nodesOrdered.map(x => x.data)
    // } else {
    //   tracksOrdered = this.tracksModel
    // }

    // this.$emit('update:tracks', tracksOrdered)
  }

  onRowDragMove(event: any) {
    const movingNode = event.node
    const overNode = event.overNode
    const rowNeedsToMove = movingNode !== overNode

    if (rowNeedsToMove) {
      const movingData = movingNode.data
      const overData = overNode.data
      const fromIndex = this.playlistsModel.indexOf(movingData)
      const toIndex = this.playlistsModel.indexOf(overData)
      const newStore = this.playlistsModel.slice()

      moveInArray(newStore, fromIndex, toIndex)

      this.playlistsModel = newStore
      this.gridApi.setRowData(newStore)
      this.gridApi.clearFocusedCell()
    }
  }

  getRowNodeId(rowItem: any) {
    return rowItem._id
  }

  getNodeChildDetails(playlist: Playlist) {
    if (playlist.type === PLAYLIST_TYPES.Playlist) return null

    const children: any[] = playlist.playlists

    return {
      group: true, // Must be true
      expanded: playlist.type === PLAYLIST_TYPES.Folder,
      children,
      key: playlist._id
    }
  }

  @Watch('quickFilterModel')
  updateTableQuickFilter(v: string) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(v)
    }
  }

  @Watch('playlists')
  watchPlaylists() {
    this.selectedPlaylists = []

    this.playlistsModel = this.playlists

    if (this.gridApi) {
      this.gridApi.setRowData(this.playlistsModel)
    }
  }
}
